import { createContext } from 'preact';

// eslint-disable-next-line import/prefer-default-export
export const IsMobileLayoutContext = createContext(false);
